// extracted by mini-css-extract-plugin
export default {"header":"form-header_header__YRlE1","bottom-block":"form-header_bottom-block__ptCJD"};